import React from 'react';

const TABS = [
  { key: 'home',       icon: '🏠', label: 'ホーム' },
  { key: 'textSelect', icon: '📚', label: 'ほんをよむ' },
  { key: 'record',     icon: '📊', label: 'きろく' },
  { key: 'ranking',    icon: '⭐', label: 'ランキング' },
];

export default function BottomNav({ active, onNav }) {
  return (
    <nav className="v9-bottom-nav">
      {TABS.map((tab) => (
        <button
          key={tab.key}
          className={`v9-nav-item${active === tab.key ? ' active' : ''}`}
          onClick={() => onNav(tab.key)}
        >
          <span className="v9-nav-icon">{tab.icon}</span>
          <span>{tab.label}</span>
        </button>
      ))}
    </nav>
  );
}
